import React from "react";
import { connect } from "react-redux";
import "./Draggable.css";
import arrayMove from "array-move";
import HELPERS from "utils/helper";
import SortableList from "./SortableList";
import {
  selectTargetWorkEnvironment,
  addWorkEnvironmentAsync,
  deleteWorkEnvironmentAsync,
  updateWorkEnvironmentAsync,
} from "slices/targetWorkEnvironmentSlice";
import {message} from "antd";

class DraggableCompTWE extends React.Component {
  state = {
    count: 999,
    dataSource: [],
    loading: false,
  };

  getWorkEnvironment = (all) => {
    return this.props.workEnvironments
      ? this.props.workEnvironments
          .filter((item) => all === true || item.learn_more === true)
          .sort((a, b) => a.priority - b.priority)
      : [];
  };

  addNew = () => {
    const data = {
      title: `Enter Criteria`,
      priority: this.getWorkEnvironment(true).length + 1,
      learn_more: true,
      selected_for: [],
      research_questions: [],
      additional_questions: [],
      reflections: [],
    };
    const formdata = HELPERS.converToFormData(data);
    this.props.addWorkEnvironmentAsync(formdata);
  };

  deleteItem = (index) => {
    this.props.deleteWorkEnvironmentAsync(this.getWorkEnvironment()[index].id);
  };

  changeText = (e, index) => {
    HELPERS.log(e.target.value, index, this.getWorkEnvironment()[index].title);
    if (this.getWorkEnvironment()[index].title !== e.target.value) {
      this.props.updateWorkEnvironmentAsync(this.getWorkEnvironment()[index].id, {
        title: e.target.value,
      });
      message.success('Your work has been saved');
    }
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      var oldData = [...this.getWorkEnvironment()];
      const newData = arrayMove(oldData, oldIndex, newIndex);
      HELPERS.log(newData);
      let priority = 1;

      newData.forEach((item) => {
        const data = {
          priority: priority,
        };
        this.props.updateWorkEnvironmentAsync(item.id, data);
        priority += 1;
      });
      message.success('Your work has been saved');
    }
  };

  getListItems = () => {
    const items = [];

    this.getWorkEnvironment().forEach((item) => {
      items.push({
        id: item.id,
        title: item.title,
      });
    });

    return items;
  };

  render() {
    return (
      <>
        {!this.state.loading && (
          <SortableList
            isDone={this.props.isDone}
            items={this.getListItems()}
            onSortEnd={this.onSortEnd}
            onChangeText={this.changeText}
            onDeleteItem={this.deleteItem}
            onAddItem={this.addNew}
            addTitle={"Add Criteria"}
            step={'TWE'}
            buttonVisible={this.props.buttonVisible}

          />
        )}
        <></>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  workEnvironments: selectTargetWorkEnvironment(state),
});

const mapDispatchToProps = () => ({
  addWorkEnvironmentAsync,
  deleteWorkEnvironmentAsync,
  updateWorkEnvironmentAsync,
});

export default connect(mapStateToProps, mapDispatchToProps())(DraggableCompTWE);
